import {useState, useRef, useEffect} from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { makeStyles, Grid } from '@material-ui/core';
import Page from '../../../../atoms/layout/page';
import Sidebar from '../sidebar';
import IconButton from '@material-ui/core/IconButton';
import ListIcon from '@material-ui/icons/List';
import BillingComponent from "./billing";
import SimpleBillingComponent from "./simple_billing";
import Config from "../../../../../config/config";
import { getBillingDetails, getAdminUsers, getRoles,getStripeCustomerDetail } from "../../../../../store/actions/admin/user";

const useStyles = makeStyles((theme) => ({
  root: {
    height: '100%',
    display: 'flex',
    position: 'relative'
  },
  menu: {
    position: 'absolute',
    right: 10,
    top: 10,
    borderRadius: 20,
    width: 40,
    height: 40,
    [theme.breakpoints.up('md')]: {
      display: 'none'
    }
  }
}));

function MailView() {
  const classes = useStyles();
  const dispatch = useDispatch();
  const pageRef = useRef(null);
  const loginUserData = localStorage.getItem("user_data") ? JSON.parse(localStorage.getItem("user_data") || '{}') : "";
  const { billingDetails, users, roles } = useSelector((state: any) => state.adminUser);
  const apolloClient = useSelector((state: any) => state.apolloClient);
  
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const [isLoading, setIsLoading] = useState(true);
  const [Details, setDetails] = useState<any>();
  const [BillingDetails, setBillingDetails] = useState<any>();

  
  const useSimpleBilling = Config.billing.strategy === "prepaid" ? true : false;

  useEffect(() => {
    const request = { username: loginUserData.username };
    dispatch(getBillingDetails(apolloClient.client, request));
    
    const request1 = { customer_name: loginUserData.customer_name };
    dispatch(getAdminUsers(apolloClient.client, request1));
    dispatch(getRoles(apolloClient.client, request1));


  }, [apolloClient.client, dispatch, loginUserData.user_id]);

  useEffect(() => {
    if(billingDetails && users && roles){
      loginUserData.role_name =billingDetails.data.roleData.role_name
      loginUserData.role_id =billingDetails.data.roleData.role_id
      loginUserData.role_alias =billingDetails.data.roleData.role_alias
      loginUserData.role_description =billingDetails.data.roleData.role_description
      loginUserData.role_access =billingDetails.data.role_access
      localStorage.setItem("user_data",JSON.stringify(loginUserData))
      const temp_detail: any = [];
      temp_detail['billingDetails'] = billingDetails;
      temp_detail['users'] = users;
      temp_detail['roles'] = roles;
      setBillingDetails(billingDetails);
      setDetails(temp_detail);
      setIsLoading(false)
      if(billingDetails.data.stripe_customer_id){
        const req = { stripe_customer_id: billingDetails.data.stripe_customer_id };
        dispatch(getStripeCustomerDetail(apolloClient.client, req));
      }
    }
  }, [billingDetails, users, roles]);
  
  return (
    <Page
      className={classes.root}
      title={"Billing"}
      ref={pageRef}
    >
      <Grid container>
        <Grid item md={2}>
          <Sidebar containerRef={pageRef} sidebarOpen={sidebarOpen} closeSidebar={()=>setSidebarOpen(false)} billingdetails={BillingDetails} />
        </Grid>
        <Grid item md={10} className="p-20">
          {/* <Box m={12}> */}
            <IconButton onClick={()=>setSidebarOpen(true)} className={classes.menu} color="primary" aria-label="add to shopping cart">
              <ListIcon />
            </IconButton>
            { useSimpleBilling ?
              <SimpleBillingComponent details={Details} loader={isLoading}/>
              :
              <BillingComponent details={Details} loader={isLoading}/>
            }
          {/* </Box> */}
        </Grid>
      </Grid>
    </Page>
  );
}

export default MailView;
